import upsell from "../upsell"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("shopping_list"),

  init() {
    this.commonInit()
  },

  onInit() {
    this.initUpsell()
  },
})
